import { useEffect, useState } from "react";
import { useDiorama } from "../../../contexts/DioramaContext";

// import background from different source if source code is buil with vite
const getBackgrounds = async () => {
	const data = await (import.meta.env.MODE === "development"
		? import("../../../data/bg.yaml")
		: import("../../../data/bg_processed.yaml"));
	return data.default;
};

const BackgroundSelector: React.FC = () => {
	const { state, dispatch } = useDiorama();
	const [backgrounds, setBackgrounds] = useState<Background[]>([]);

	const handleBackgroundSelect = (background: Background) => {
		dispatch({ type: "SET_BACKGROUND", background });
	};

	useEffect(() => {
		const fetchBackgrounds = async () => {
			const data = await getBackgrounds();
			setBackgrounds(data as Background[]);
		};
		fetchBackgrounds();
	}, []);

	return (
		<div>
			<h2 className="text-xl font-semibold mb-4">
				Step 1: Choose a Background
			</h2>
			<p className="mb-4">Select a background scene for your diorama</p>

			<div className="grid grid-cols-2 gap-4">
				{backgrounds &&
					backgrounds.map((bg) => (
						<div
							key={bg.id}
							className={`cursor-pointer border-2 rounded overflow-hidden hover:opacity-90 transition-opacity ${
								state.background?.id === bg.id
									? "border-amber-600"
									: "border-gray-200"
							}`}
							onClick={() => handleBackgroundSelect(bg)}
							onKeyUp={(e) => {
								if (e.key === "Enter" || e.key === " ") {
									handleBackgroundSelect(bg);
								}
							}}
						>
							<img
								src={bg.image}
								alt={bg.name}
								className="w-full h-32 object-cover"
							/>
							<div className="p-2 text-center bg-gray-50">
								<p>{bg.name}</p>
							</div>
						</div>
					))}
			</div>
		</div>
	);
};

export default BackgroundSelector;
